import React from "react";
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBView, MDBContainer, MDBMask, MDBTypography } from
"mdbreact";
import classes from "./slider.css"
const Slider = () => {
  return (
    
      <MDBCarousel md="12" 
        activeItem={1}
        length={3}
        showControls={true}
        showIndicators={true}
        className="z-depth-1 d-block carousel"
        slide
      >
        <MDBCarouselInner className="carouselInner">
          <MDBCarouselItem itemId="1" active className="carouselItem">
            <MDBView className="">
              <img
                className="d-block w-100 view"
                src="https://mdbootstrap.com/img/Photos/Slides/img%20(15).jpg"
                alt="First slide"
              />
                 <MDBMask className="rgba-black-light d-flex justify-content-left align-items-center">
      
                                <div class="text-center white-text mx-5 wow fadeIn">
                                  <h1 class="mb-4">
                                    <strong> Pioneer in </strong><span class="text-info"><strong>Dairy industry</strong></span>
                                  </h1>

                                  <p>
                                    <strong>Since 1973</strong>
                                  </p>

                                  <a  href="/milkProducts" class="btn btn-outline-white btn-lg">
                                    view our Products
                                    <i class="fas fa-address-card ml-2"></i>
                                  </a>
                                </div>



                 </MDBMask>
            </MDBView>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="2"  className="carouselItem">
            <MDBView>
              <img
                className="d-block w-100 view"
                src="https://mdbootstrap.com/img/Photos/Slides/img%20(22).jpg"
                alt="Second slide"
              />
            </MDBView>
          </MDBCarouselItem>
          <MDBCarouselItem itemId="3"  className="carouselItem">
            <MDBView>
              <img
                className="d-block w-100 view"
                src="https://mdbootstrap.com/img/Photos/Slides/img%20(23).jpg"
                alt="Third slide"
              />
            </MDBView>
          </MDBCarouselItem>
        </MDBCarouselInner>
      </MDBCarousel>

  );
}

export default Slider;